import React from "react";

import "./Footer.css";
import { images } from "../../constants";

var theDate = new Date();
var yr = theDate.getFullYear();

const Footer = () => (
	<div className=" app__bg section__padding app__footer">
		<div className="app__footer-links flex__center">
			<h1>Mary Matha Catering and Events Management </h1>
			<p>"Make memories while we make your occasion special"</p>
			<img
				src={images.spoon}
				loading="lazy"
				className="spoon__img"
				alt="spoon"
			/>
		</div>

		<div className="footer__copyright flex__center">
			<p>Copyright © 2013 - {yr} - All Rights Reserved </p>
		</div>
	</div>
);

export default Footer;
